<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">
          Thông tin cá nhân
        </h3>
      </div>
      <div class="card-body">
        <form action="">
          <div class="form-group">
            <div class="row align-items-center">
              <label class="col-sm-3">Họ tên:</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="userInfo.name"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row align-items-center">
              <label class="col-sm-3">Email:</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="userInfo.email"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row align-items-center">
              <label class="col-sm-3">Địa chỉ :</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="userInfo.address"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row align-items-center">
              <label class="col-sm-3">Nơi làm việc:</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="userInfo.workPlace"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row align-items-center">
              <label class="col-sm-3">Số điện thoại:</label>
              <div class="col-sm-9">
                <input
                  type="text"
                  class="form-control"
                  v-model="userInfo.phone"
                />
              </div>
            </div>
          </div>

          <div class="btn-list mt-4 text-right">
            <el-button @click="reset">Reset</el-button>
            <el-button
              ref="confirmButton"
              type="primary"
              @click="onSubmitEditUserInformation"
            >
              Xác nhận
            </el-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getUserProfile } from "@/services/authentication_service"
import { updateProfile } from "@/services/user_service"
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "UserInformation",
  components: { FAIcon },
  data: function () {
    return {
      backupInfo: {},
      userInfo: {},
    }
  },
  methods: {
    async onSubmitEditUserInformation() {
      this.$refs.confirmButton.loading = true
      let res = await updateProfile(this.$data.userInfo)
      if (res != null) {
        this.$message.success("Cập nhật thông tin thành công")
      } else {
        this.$message.error("Có lỗi xảy ra")
      }
      this.$refs.confirmButton.loading = false
    },
    reset() {
      this.userInfo = Object.assign({}, this.backupInfo)
    },
    gotoHome() {
      this.$router.push({ name: "home" })
    },
    onError(msg) {
      this.$message.error(msg)
      setTimeout(this.gotoHome, 1500)
    },
  },
  async mounted() {
    let info = await getUserProfile(this.onError)
    if (info != null) {
      this.userInfo = info
    } else {
      this.onError("Có lỗi xảy ra")
    }
    this.backupInfo = Object.assign({}, this.userInfo)
  },
}
</script>

<style scoped>
.card-title {
  margin: 0;
}

.el-form {
  margin: 20px 30px;
  width: 50%;
}

.el-tabs--left .el-tabs__header.is-left {
  margin-right: 70px;
}

.card .card-header {
  background-color: rgba(0, 0, 0, 0);
}

.card .card-header .card-title {
  font-size: 22px;
}

.btn-secondary {
  background-color: white;
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
}

.btn-secondary:hover {
  background-color: rgba(81, 81, 81, 0.1);
  color: rgba(0, 0, 0, 0.6);
}

.card-body {
  margin: 0 8%;
}

.btn-primary {
  margin-bottom: 0.5rem;
  font-size: 14px;
  font-weight: 600;
}
</style>
